import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-expand-collapse-toggle',
  imports: [TranslocoPipe],
  templateUrl: './expand-collapse-toggle.component.html',
  styleUrl: './expand-collapse-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ExpandCollapseToggleComponent {
  items = input.required<{ expand?: boolean }[]>();
  loading = input<boolean>(false);
  expandLabel = input<string>(
    'project_details_screen_budget_tab_expand_all_button_label'
  );
  collapseLabel = input<string>(
    'project_details_screen_budget_tab_collapse_all_button_label'
  );
  idPrefix = input<string>('expand-collapse-toggle');
  expandAll = output<void>();
  collapseAll = output<void>();
  isAllCollapsed = computed<boolean>(() => {
    const list = this.items();
    if (list.length === 0) return true;
    return list.every(item => !item.expand);
  });

  isAllExpanded = computed<boolean>(() => {
    const list = this.items();
    return list.length !== 0 && list.every(item => item.expand);
  });

  isExpandDisabled = computed<boolean>(
    () => this.isAllExpanded() || this.loading()
  );

  isCollapseDisabled = computed<boolean>(
    () => this.isAllCollapsed() || this.loading()
  );

  onExpandAll() {
    if (!this.isExpandDisabled()) {
      this.expandAll.emit();
    }
  }

  onCollapseAll() {
    if (!this.isCollapseDisabled()) {
      this.collapseAll.emit();
    }
  }
}
